import { render, staticRenderFns } from "./detail-component-products.vue?vue&type=template&id=674ad80d&scoped=true"
import script from "./detail-component-products.vue?vue&type=script&lang=ts"
export * from "./detail-component-products.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674ad80d",
  null
  
)

export default component.exports